<template>
    <div>
        <!--
        <b-dropdown id="ddown1" text="Dropdown Button" class="m-md-2">
    <b-dropdown-item @click="alert('sdf')">First Action</b-dropdown-item>
    <b-dropdown-item>Second Action</b-dropdown-item>
    <b-dropdown-item>Third Action</b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item>Something else here...</b-dropdown-item>
    <b-dropdown-item disabled>Disabled action</b-dropdown-item>
  </b-dropdown>
  -->
    </div>
</template>

<script>
import axios from 'axios';

import bModal from 'bootstrap-vue/es/components/modal/modal'

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
      return {
          r: []
      }
  },
  created() {
      this.$http.get('v1/qg')
      .then(response => {
          console.log(response);
          this.r = response.data.response;
      })
  },
  components: {
      'b-modal': bModal
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
